import React from 'react';
import classNames from 'classnames';
import Dummy from '../Dummy';
import styles from './style.css';


export default class Status extends Dummy {

    render() {
        let statusClass = {};
        let text = '';

        let val = this.props.ps;
        if (!val.disabled) {
            statusClass[this.props.zeroClass] = !val.cleaned;
            statusClass[this.props.oneClass] = val.cleaned;
            val.cleaned ? text = this.props.oneText : text = this.props.zeroText
        } else {
            text = this.props.disabledText || '?';
            statusClass[this.props.disabledClass || styles.disabled] = true;
        }

        //Render vars
        let statusClassStr = classNames(this.props.className || styles.status, statusClass);
        let div_id = this.props.div_id;

        return (
            <th className={statusClassStr} id={div_id}>   {/*TODO: tag in props*/}
                {text}
            </th>
        );
    }
}

Status.propTypes = {
    ps: React.PropTypes.object.isRequired,
    zeroClass: React.PropTypes.string.isRequired,
    oneClass: React.PropTypes.string.isRequired,
    zeroText: React.PropTypes.string.isRequired,
    oneText: React.PropTypes.string.isRequired,
    disabledText: React.PropTypes.string,
    disabledClass: React.PropTypes.string,
    className: React.PropTypes.string,
    div_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/lib/core/Status/index.jsx